import { ExecutorPlaceholder } from '../../../OptionsExecutor/OptionsExecutor';
import { ButtonActionDrop } from '../../../Buttons/ButtonActionDrop/ButtonActionDrop';
import './EcexutorRow.scss'

const EcexutorRow = ({
    key,
    name,
    login,
    id,
    color,
    isAdmin = true,
    deleteMember,
    role_id,
    role_name,
    setCurrentMember,
    setIsModal = () => { }
}) => {

    const btns = [
        {
            btn: 'Редактировать', func: () => {
                setCurrentMember({
                    name,
                    login,
                    id,
                    color,
                    isAdmin,
                    deleteMember,
                    role_id,
                    role_name,
                })
                setIsModal(true)
            }
        },
        ...role_id !== 5 ? [{ btn: 'Удалить', func: () => deleteMember() }] : []
    ]

    return (
        <div className='executor-row' key={key}>
            <div className='executor-row__name'>
                <ExecutorPlaceholder
                    name={name}
                    email={login}
                    color={color}
                    isShowInfo
                    hideTooltip
                    role_id={role_id}
                    role_name={role_name}
                />
            </div>
            <div className='executor-row__tools'>
                {
                    isAdmin ?
                        <div className='settings-row__btns'>
                            <ButtonActionDrop
                                id={id}
                                btns={btns}
                            />
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}

export { EcexutorRow }
